export const TakeOverScreen = async (screen_item, idx, notify, configData, getToken, setScreenData, selectedScreens) => {
    try {
      
      const screensForRow = selectedScreens[idx];
      if (!screensForRow || screensForRow.size === 0) {
        notify("Please select at least one screen before pressing Ready", "error");
        return false;
      }
    const screensArray = Array.from(screensForRow);
    const token = getToken()
    if (!screen_item){
      notify("No Data To Push To Screen", "error");
      return false
    }

    const bodyData = {
      "screenData": screen_item['value'],
      "screenId": screensArray,
    };
    // return
    const res = await fetch(`${configData.DEMO_URL}/TakeOverScreen`, {
        method: "POST",
        headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
        // add auth token if needed
        },
        body: JSON.stringify(bodyData),
    });

    if (!res.ok) {
      // handle 404 separately
      if (res.status === 404) {
        let errorMessage = "Resource not found";
        try {
          const errorBody = await res.json();
          if (errorBody?.message) {
            errorMessage = errorBody.message;
          }
        } catch (_) {}
        notify(errorMessage, "error");
        return false;
      }

      throw new Error(`Failed To Take Over Screen`);
    }
    setScreenData(null)
    return true
    } catch (error) {
      if (error.message) {
        notify(error.message, "error");
      } else {
        notify("Failed To Take Over Screen", "error");
      }
      
      return false;
    }
};